import LoginForm            from "./LoginForm";
import ChangePasswordForm   from "./ChangePasswordForm";
import axios                from "axios"
import { useState }         from "react"
import { useNavigate }      from "react-router-dom";
import { useUser }          from "../../contexts/UserContext";


export default function LoginFormContainer (){

    const [ statusLogin, setStatusLogin ]   = useState("")
    // 'erro' pinta a mensagem de vermelho; 'sucesso' de verde. A troca de senha
    // pode terminar bem e ainda assim voltar para o login (ver abaixo), e essa
    // mensagem não pode parecer falha.
    const [ statusTone, setStatusTone ]     = useState("erro")
    // guarda as credenciais do login que caiu no 403 requiresPasswordChange,
    // para usar como oldPassword na troca e relogar em seguida
    const [ pendingCreds, setPendingCreds ] = useState(null)
    const navigate                          = useNavigate();
    const { setToken } = useUser()

    const doLogin = async (loginData) => {

        const response  = await axios.post('/auth', {loginData} )
        const { token } = response.data;
        setToken(token)

        localStorage.setItem("token", token);

        navigate("/home")
    }

    const handerSubmit = async (loginData) => {

        try{

            setStatusLogin("")
            setStatusTone("erro")

            await doLogin(loginData)

        }catch(error){

            // 1º login (ou senha resetada): backend exige troca de senha
            if (error.response?.status === 403 && error.response?.data?.requiresPasswordChange) {
                setPendingCreds(loginData)
                return
            }

            console.log(error)
            setStatusLogin(error.response?.data?.message || error.response?.data?.error || 'Erro ao fazer login')
        }

    }

    const handleChangePassword = async ({ newPassword }) => {

        const senhaNova = newPassword.trim()

        try{

            setStatusLogin("")
            setStatusTone("erro")

            await axios.put('/changePassword', {
                username:    pendingCreds.username,
                oldPassword: pendingCreds.password,
                newPassword: senhaNova,
            })

        }catch(error){

            console.log(error)
            setStatusLogin(error.response?.data?.message || error.response?.data?.error || 'Erro ao trocar a senha')
            return
        }

        // Daqui para baixo a senha JÁ mudou no servidor: a antiga morreu.
        // Se o login falhar agora (429, rede, servidor fora), não dá para
        // deixar o usuário retentando a troca — ele mandaria a senha antiga
        // como oldPassword, levaria 'Credenciais incorretas' e concluiria que
        // a troca não funcionou, sem saber que a senha nova já é a válida.
        try{

            await doLogin({ username: pendingCreds.username, password: senhaNova })

        }catch(error){

            console.log(error)
            setPendingCreds(null)
            setStatusTone("sucesso")
            setStatusLogin(
                'Sua senha FOI alterada com sucesso. Não conseguimos entrar automaticamente — ' +
                'faça login com a senha nova.'
            )
        }

    }

    if (pendingCreds) {
        return(<ChangePasswordForm onSubmit={handleChangePassword} responseMessage={statusLogin} username={pendingCreds.username}/>)
    }

    return(<LoginForm onSubmit={handerSubmit} responseMessage={statusLogin} messageTone={statusTone}/>)
}
